import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'events-polyfill';
import 'formdata-polyfill';

/* array polyfills for IE support */
import 'core-js/features/array/find';
import 'core-js/features/array/find-index';
import 'core-js/features/array/includes';
import 'core-js/features/array/flat-map';
/* string polyfills for IE support */
import 'core-js/features/string/includes';
import 'core-js/features/string/ends-with';
import 'core-js/features/string/starts-with';
/* object polyfills for IE support */
import 'core-js/features/object/entries';
/* URL polyfills for IE support */
import 'core-js/features/url-search-params';

import 'regenerator-runtime/runtime';

import { ConnectedRouter } from 'connected-react-router';
import React from 'react';
import get from 'lodash/get';
import set from 'lodash/set';
import { hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './../common/store/configureStore';
import { getSiteRoutes, graphqlApiUrl } from './../common/utils';
import LocaleContext from '../common/context/locale';

import { After, ensureReady } from '@jaredpalmer/after';

// Fixes HMR by avoiding recreating the history instance
import history from './history';

import { ApolloClient } from '@apollo/client';
import { InMemoryCache } from '@apollo/client/cache';

const apolloClient = new ApolloClient({
  uri: graphqlApiUrl,
  credentials: 'include',
  cache: new InMemoryCache().restore(window.__APOLLO_STATE__)
});

const routes = getSiteRoutes().default;

// FIXME hydrate state.i18n from cookie
const store = configureStore(history, window.__PRELOADED_STATE__);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then(registration => {})
      .catch(registrationError => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

const prepareAndRun = async () => {
  const data = await ensureReady(routes);
  const language = get(
    data,
    'initialData.page.page.countrySite.language',
    'en'
  );
  const {
    locale: dateLocale
  } = await import(/* webpackChunkName: "locale-[request]" */ `../common/i18n/locales/${language}.js`);

  return hydrate(
    <Provider store={store}>
      <LocaleContext.Provider value={{ dateLocale }}>
        <ConnectedRouter history={history}>
          <After
            data={set(data, 'initialData.apolloClient', apolloClient)}
            routes={routes}
            apolloClient={apolloClient}
          />
        </ConnectedRouter>
      </LocaleContext.Provider>
    </Provider>,
    document.getElementById('root')
  );
};

prepareAndRun();

if (module.hot) {
  module.hot.accept();
}
